import { useEffect, useState } from 'react';
import safeStorage from '../utils/safeStorage';

export function useLocalStorage(key, initialValue) {
  const readValue = () => {
    const stored = safeStorage.getItem(key);
    if (stored === null || stored === undefined) return initialValue;
    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  };

  const [storedValue, setStoredValue] = useState(readValue);

  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);

      if (valueToStore === undefined) {
        safeStorage.removeItem(key);
      } else {
        safeStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  };

  useEffect(() => {
    setStoredValue(readValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return [storedValue, setValue];
}
